export default class Spf {
  constructor() {
    this.name = true;
    this.title = true;
    this.organization = true;
    this.relationship = true;
    this.country = true;
  }

  loadData(payload) {
    if (payload.Political_Figure_Info) {
      this.name = payload.Political_Figure_Info.Name;
      this.title = payload.Political_Figure_Info.Title;
      this.organization = payload.Political_Figure_Info.Organization;
      this.relationship = payload.Political_Figure_Info.Relationship;
      this.country = payload.Political_Figure_Info.Country;
    }
  }
}
